<!--sass需求717，保留一个首页，这里隐藏之前的逻辑-->
<!--更改时间：20201222-->

<!--<template>-->
  <!--&lt;!&ndash;集团系统首页&ndash;&gt;-->
  <!--<div>-->
<!--&lt;!&ndash;    <el-row type="flex" align="middle" class="n-user">&ndash;&gt;-->
<!--&lt;!&ndash;      <el-col :span="16" class="fr user-box">&ndash;&gt;-->
<!--&lt;!&ndash;        <el-row style="height: 100%;" type="flex" align="middle">&ndash;&gt;-->
<!--&lt;!&ndash;          <el-col :span="3" class="fl user-photo">&ndash;&gt;-->
<!--&lt;!&ndash;            <img :src="avatar" onerror="this.src = '/images/touxiang66.png'"/>&ndash;&gt;-->
<!--&lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;          <el-col :span="21" class="fl user-info">&ndash;&gt;-->
<!--&lt;!&ndash;            <el-tooltip :disabled="!departmentInfo" :content="'部门：'+departmentInfo" placement="right">&ndash;&gt;-->
<!--&lt;!&ndash;              <p style="cursor: default;display: inline-block;">&ndash;&gt;-->
<!--&lt;!&ndash;                {{corpUser|lessThan(20)}}&ndash;&gt;-->
<!--&lt;!&ndash;              </p>&ndash;&gt;-->
<!--&lt;!&ndash;            </el-tooltip>&ndash;&gt;-->
<!--&lt;!&ndash;            <p style="color: #989898;">&ndash;&gt;-->
<!--&lt;!&ndash;              账号：&ndash;&gt;-->
<!--&lt;!&ndash;              <template v-if="$store.getters.authUser.userType === 1">{{$store.getters.authUser.emailMask}}</template>&ndash;&gt;-->
<!--&lt;!&ndash;              <template v-else>{{$store.getters.authUser.mobileMash}}</template>&ndash;&gt;-->
<!--&lt;!&ndash;            </p>&ndash;&gt;-->
<!--&lt;!&ndash;            <p>&ndash;&gt;-->
<!--&lt;!&ndash;              <span  class="auth-icon auth-did"&ndash;&gt;-->
<!--&lt;!&ndash;                    v-if="$store.getters.allAuthUser.accountInfoVO && $store.getters.allAuthUser.accountInfoVO.identityAuth === 1">&ndash;&gt;-->
<!--&lt;!&ndash;                <i class="el-icon-circle-check"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                已实名认证&ndash;&gt;-->
<!--&lt;!&ndash;              </span>&ndash;&gt;-->
<!--&lt;!&ndash;              <span v-else class="auth-icon auth-not">&ndash;&gt;-->
<!--&lt;!&ndash;                <i class="el-icon-circle-close"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                未实名认证&ndash;&gt;-->
<!--&lt;!&ndash;              </span>&ndash;&gt;-->
<!--&lt;!&ndash;            </p>&ndash;&gt;-->
<!--&lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;        </el-row>&ndash;&gt;-->
<!--&lt;!&ndash;      </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;      <el-col :span="8">&ndash;&gt;-->
<!--&lt;!&ndash;        <el-row type="flex" align="middle" class="fl user-point">&ndash;&gt;-->
<!--&lt;!&ndash;          &lt;!&ndash; 企业用户，显示套餐数量 &ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;          <el-col :span="12" class="file-count">&ndash;&gt;-->
<!--&lt;!&ndash;            <p class="title">&ndash;&gt;-->
<!--&lt;!&ndash;              <span>剩余文件数</span>&ndash;&gt;-->
<!--&lt;!&ndash;            </p>&ndash;&gt;-->
<!--&lt;!&ndash;            <p style="line-height: 27px;">&ndash;&gt;-->
<!--&lt;!&ndash;              <span style="font-size: 24px; color: #333333;">{{remainCnt}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;              <span style="line-height: 16px;">份</span>&ndash;&gt;-->
<!--&lt;!&ndash;            </p>&ndash;&gt;-->
<!--&lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;          <el-col :span="12" class="point-count">&ndash;&gt;-->
<!--&lt;!&ndash;            <p class="title">&ndash;&gt;-->
<!--&lt;!&ndash;              <span>剩余积分</span>&ndash;&gt;-->
<!--&lt;!&ndash;            </p>&ndash;&gt;-->
<!--&lt;!&ndash;            <p style="line-height: 27px;">&ndash;&gt;-->
<!--&lt;!&ndash;              <span style="font-size: 24px; color: #333333;">{{userPointCnt}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;              <span style="line-height: 16px;">分</span>&ndash;&gt;-->
<!--&lt;!&ndash;            </p>&ndash;&gt;-->
<!--&lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;        </el-row>&ndash;&gt;-->
<!--&lt;!&ndash;      </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;    </el-row>&ndash;&gt;-->

<!--&lt;!&ndash;    <el-row type="flex" align="middle" v-if="signCount" class="text-center totals-sign" style="padding: 0;">&ndash;&gt;-->
<!--&lt;!&ndash;      <el-col :span="14">&ndash;&gt;-->
<!--&lt;!&ndash;        <el-row class="sign-count">&ndash;&gt;-->
<!--&lt;!&ndash;          <el-col :span="8">&ndash;&gt;-->
<!--&lt;!&ndash;            <div @click="$router.push({path: '/corp/signInfo/signList', query: {signStatus: 2}})" class="item">&ndash;&gt;-->
<!--&lt;!&ndash;              <img src="/images/unsign2.png">&ndash;&gt;-->
<!--&lt;!&ndash;              <p class="count-num">{{signCount.noFinishCount || 0}}</p>&ndash;&gt;-->
<!--&lt;!&ndash;              <p>未完成</p>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;          <el-col :span="8">&ndash;&gt;-->
<!--&lt;!&ndash;            <div @click="$router.push({path: '/corp/signInfo/signList', query: {signStatus: 3}})" class="item">&ndash;&gt;-->
<!--&lt;!&ndash;              <img src="/images/signed2.png">&ndash;&gt;-->
<!--&lt;!&ndash;              <p class="count-num">{{signCount.finishCount || 0}}</p>&ndash;&gt;-->
<!--&lt;!&ndash;              <p>已结束</p>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;          <el-col :span="8">&ndash;&gt;-->
<!--&lt;!&ndash;            <div @click="$router.push({path: '/corp/signInfo/applyList', query: {signStatus: 4}})" class="item">&ndash;&gt;-->
<!--&lt;!&ndash;              <img src="/images/drafts2.png">&ndash;&gt;-->
<!--&lt;!&ndash;              <p class="count-num">{{signCount.draftBoxCount || 0}}</p>&ndash;&gt;-->
<!--&lt;!&ndash;              <p>草稿箱</p>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;        </el-row>&ndash;&gt;-->
<!--&lt;!&ndash;      </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;      <el-col :span="10" class="signed">&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="line-head">&ndash;&gt;-->
<!--&lt;!&ndash;          &lt;!&ndash; <nuxt-link to="/signInfo/viewGuide" class="fl color-danger">新手指引</nuxt-link> &ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;					<a href="javascript:void(0);" @click="visibleGuideView = true" class="fl color-danger">新手指引</a>&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="fr" style="color: #646464;">&ndash;&gt;-->
<!--&lt;!&ndash;            <el-tooltip effect="dark" placement="bottom-start">&ndash;&gt;-->
<!--&lt;!&ndash;              <p slot="content" style="width: 200px;line-height: 1.5;">&ndash;&gt;-->
<!--&lt;!&ndash;                1.仅支持pdf、doc、docx、jpg、png、bmp格式&ndash;&gt;-->
<!--&lt;!&ndash;                <br>&ndash;&gt;-->
<!--&lt;!&ndash;                2.文件小于20M&ndash;&gt;-->
<!--&lt;!&ndash;                <br>&ndash;&gt;-->
<!--&lt;!&ndash;                其它格式文件请先转化成pdf格式上传，文件内容范围请确保在A4~A0大小&ndash;&gt;-->
<!--&lt;!&ndash;              </p>&ndash;&gt;-->
<!--&lt;!&ndash;              <span style=" cursor: default;">&ndash;&gt;-->
<!--&lt;!&ndash;                  <span style="vertical-align: middle;">&ndash;&gt;-->
<!--&lt;!&ndash;                    发起须知&ndash;&gt;-->
<!--&lt;!&ndash;                  </span>&ndash;&gt;-->
<!--&lt;!&ndash;                  <i class="el-icon-question" style="margin-left: 5px; font-size: 16px; vertical-align: middle;"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                </span>&ndash;&gt;-->
<!--&lt;!&ndash;            </el-tooltip>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;        <file-sign-create/>&ndash;&gt;-->
<!--&lt;!&ndash;        <router-link to="/tpl/general" style="color: #118E8E;" class="fl">&ndash;&gt;-->
<!--&lt;!&ndash;          <i class="icon icon-tpl" style="vertical-align: middle;"></i>&ndash;&gt;-->
<!--&lt;!&ndash;          <span style="margin-left: 10px; margin-right: 5px; vertical-align: middle;">模板发起签署</span>&ndash;&gt;-->
<!--&lt;!&ndash;          <span class="db-arrow" right style="vertical-align: middle;"></span>&ndash;&gt;-->
<!--&lt;!&ndash;        </router-link>&ndash;&gt;-->
<!--&lt;!&ndash;      </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;    </el-row>&ndash;&gt;-->
    <!--&lt;!&ndash;      隐藏：最近文件&ndash;&gt;-->
    <!--<div class="latest" style="display: none;">-->
      <!--<p class="header">-->
        <!--<span class="title">最近文件</span>-->
        <!--<router-link :to="{path: '/corp/signInfo/signList', query: {signStatus: 2}}" class="fr"-->
                     <!--style="color: #808080;">-->
          <!--<span style="vertical-align: middle;">查看更多</span>-->
          <!--<span class="db-arrow" right style="vertical-align: middle;"></span>-->
        <!--</router-link>-->
      <!--</p>-->
      <!--<el-table-->
        <!--:data="fileList"-->
        <!--style="width: 100%"-->
        <!--border-->
        <!--:header-cell-style="{background: '#F1F1F1', color: '#353535', fontWeight: '600'}"-->
        <!--class="table">-->
        <!--<el-table-column label="文件名称" show-overflow-tooltip>-->
          <!--<template slot-scope="scope">-->
            <!--<corp-apply-name applyType="signList" :signInfo="{signStatus: scope.row.signStatus, selfSign: scope.row.selfSign, selfApprove: scope.row.selfApprove, signNo: scope.row.signNo, contractName: scope.row.contractName, applyNo: scope.row.applyNo, approveId: scope.row.approveId}" />-->
          <!--</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column label="发起方" show-overflow-tooltip prop="ebqUserName"/>-->
        <!--<el-table-column label="签署方" show-overflow-tooltip prop="allSignerName"/>-->
        <!--<el-table-column label="状态">-->
          <!--<template slot-scope="scope">-->
            <!--<template v-if="scope.row.signStatus === -3">-->
              <!--<span v-if="scope.row.selfApprove === 1">待我审</span>-->
              <!--<span v-else>待ta审</span>-->
            <!--</template>-->
            <!--<template v-else-if="scope.row.signStatus === -4">-->
              <!--<p>审批驳回</p>-->
            <!--</template>-->
            <!--<template v-else-if="scope.row.signStatus === 0">-->
              <!--<p v-if="scope.row.selfSign === 1">待我签</p>-->
              <!--<p v-else>待ta签</p>-->
            <!--</template>-->
            <!--<template v-else-if="scope.row.signStatus === 1">-->
              <!--已完成-->
            <!--</template>-->
            <!--<template v-else-if="scope.row.signStatus === 2">-->
              <!--已拒签-->
            <!--</template>-->
            <!--<template v-else-if="scope.row.signStatus === -5">-->
              <!--已撤销-->
            <!--</template>-->
            <!--<template v-else-if="scope.row.signStatus === -6">-->
              <!--已过期-->
            <!--</template>-->
          <!--</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column label="发起时间" prop="createTime">-->
          <!--<template slot-scope="scope">{{scope.row.createTime | formatDateHM}}</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column label="操作" width="120px">-->
          <!--<template slot-scope="scope">-->
            <!--<corp-handles ref="handlesComp" :rowData="scope.row" applyType="signList"></corp-handles>-->
          <!--</template>-->
        <!--</el-table-column>-->
      <!--</el-table>-->
    <!--</div>-->
    <!--&lt;!&ndash; 产品助手，链接帮助中心 &ndash;&gt;-->
<!--&lt;!&ndash;    <el-row class="product-assist">&ndash;&gt;-->
<!--&lt;!&ndash;      <el-col :span="8">&ndash;&gt;-->
<!--&lt;!&ndash;        <a :href="domain.junziqianMain + '/file_query.html#fileVerification'" target="_blank">&ndash;&gt;-->
<!--&lt;!&ndash;          <i class="icon icon-assist"></i>&ndash;&gt;-->
<!--&lt;!&ndash;          <span>已签署的合同如何验证有效性？</span>&ndash;&gt;-->
<!--&lt;!&ndash;        </a>&ndash;&gt;-->
<!--&lt;!&ndash;      </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;      <el-col :span="8">&ndash;&gt;-->
<!--&lt;!&ndash;        <a :href="domain.junziqianMain + '/help.html#realNameProblem'" target="_blank">&ndash;&gt;-->
<!--&lt;!&ndash;          <i class="icon icon-assist"></i>&ndash;&gt;-->
<!--&lt;!&ndash;          <span>实名认证有什么用处？</span>&ndash;&gt;-->
<!--&lt;!&ndash;        </a>&ndash;&gt;-->
<!--&lt;!&ndash;      </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;      <el-col :span="8">&ndash;&gt;-->
<!--&lt;!&ndash;        <a :href="domain.junziqianMain + '/help.html#hisProblem'" target="_blank">&ndash;&gt;-->
<!--&lt;!&ndash;          <i class="icon icon-assist"></i>&ndash;&gt;-->
<!--&lt;!&ndash;          <span>签署的合同发生纠纷如何处理？</span>&ndash;&gt;-->
<!--&lt;!&ndash;        </a>&ndash;&gt;-->
<!--&lt;!&ndash;      </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;    </el-row>&ndash;&gt;-->

		<!--&lt;!&ndash; 实名认证信息 &ndash;&gt;-->
		<!--<real-name-authentication v-model="visibleIdentity" :identityInfo="identityInfo"></real-name-authentication>-->
		<!--&lt;!&ndash; 新手指引 &ndash;&gt;-->
		<!--<guide-view v-model="visibleGuideView" :src="videoSrc"></guide-view>-->

    <!--&lt;!&ndash;-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; 20200811改版start -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
    <!--<div class="box-one om">-->
      <!--<div class="top" style="justify-content: space-between">-->
        <!--<div class="t-left">-->
          <!--<div class="portrait">-->
            <!--<img :src="avatar" onerror="this.src = '/images/web/p-default.png'"/>-->
            <!--&lt;!&ndash;            已认证&ndash;&gt;-->
<!--&lt;!&ndash;            <i class="el-icon-success" style="background-color: #ffffff;border-radius: 50%;" v-if="$store.getters.allAuthUser.accountInfoVO && $store.getters.allAuthUser.accountInfoVO.identityAuth === 1"></i>&ndash;&gt;-->
<!--&lt;!&ndash;            &lt;!&ndash;            未认证&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;            <i class="icon-w" v-else></i>&ndash;&gt;-->
          <!--</div>-->
          <!--<div class="un">-->
            <!--<div style="margin-right: 10px">-->
              <!--<el-tooltip :disabled="!departmentInfo" :content="'部门：'+departmentInfo" placement="right">-->
                <!--<p style="cursor: default;">-->
                  <!--{{corpUser|lessThan(20)}}-->
                <!--</p>-->
              <!--</el-tooltip>-->
              <!--<p><span class="m" v-if="$store.getters.allAuthUser.accountInfoVO && $store.getters.allAuthUser.accountInfoVO.identityAuth === 1">-->
                <!--已实名认证</span>-->
                <!--<span class="y" v-else>未实名认证</span></p>-->
            <!--</div>-->
            <!--<label class="joined" style="color: #00cb14;cursor: default;line-height: initial;"><i class="icon el-icon-success" style="cursor: default;"></i>-->
              <!--已加入</label>-->
            <!--<div class="icon-admin" @click="$router.push({path: '/tpl/corpSet'})" title="印章管理"><i class="icon icon-z"></i>印章</div>-->
            <!--<div class="icon-admin" @click="$router.push({path: '/tpl/general'})" title="模板管理"><i class="icon icon-mb"></i>模板</div>-->
            <!--<div class="icon-admin" v-if="isShowConsoleEntry" @click="$router.push('/console')" title="企业设置"><i class="icon icon-setting"></i>设置</div>-->
          <!--</div>-->
        <!--</div>-->
        <!--<div class="t-right">-->
          <!--套餐：<span class="ft">{{remainCnt}} 份</span>-->
          <!--积分：<span class="ft">{{userPointCnt}} 分</span>-->
        <!--</div>-->
      <!--</div>-->
      <!--<div class="bottom">-->
        <!--<h1><span @click="()=>{visibleGuideView = true;this.videoSrc = this.videoSrc1}">一分钟短视频了解君子签<i class="icon icon-play"></i></span></h1>-->
        <!--<div class="con">-->
          <!--<div class="sbox" @click="$router.push({path: '/corp/signInfo/signList', query: {signStatus: 2}})">-->
            <!--<div class="unfinish"></div>-->
            <!--<div class="cont">-->
              <!--<p>{{signCount.noFinishCount || 0}}</p>-->
              <!--<p>未完成</p>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="sbox" @click="$router.push({path: '/corp/signInfo/signList', query: {signStatus: 3}})">-->
            <!--<div class="finish"></div>-->
            <!--<div class="cont">-->
              <!--<p>{{signCount.finishCount || 0}}</p>-->
              <!--<p>已结束</p>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="sbox" @click="$router.push({path: '/corp/signInfo/applyList', query: {signStatus: 4}})">-->
            <!--<div class="draft"></div>-->
            <!--<div class="cont">-->
              <!--<p>{{signCount.draftBoxCount || 0}}</p>-->
              <!--<p>草稿箱</p>-->
            <!--</div>-->
          <!--</div>-->
          <!--&lt;!&ndash;          发起&ndash;&gt;-->
          <!--<div class="brp">-->
            <!--<div class="file-box">-->
              <!--<file-sign-create>-->
                <!--<img src="/images/web/file.png"/>-->
                <!--<p>上传文件发起签署</p>-->
                <!--<p>支持pdf/doc/jpg等格式</p>-->
              <!--</file-sign-create>-->
            <!--</div>-->
            <!--<div class="file-box" @click="$router.push({path:'/tpl/general'})">-->
              <!--<img src="/images/web/mb.png"/>-->
              <!--<p>使用模板发起签署</p>-->
              <!--<p>智能生成合同</p>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->

<!--&lt;!&ndash;    登录的账户信息&ndash;&gt;-->
    <!--<div class="box-one joined">-->
      <!--<div class="top">-->
        <!--<h1 class="com-title"><i></i>{{accountInfoVO.name}}</h1>-->
        <!--<span style="display:flex;align-items:center;margin-left: 20px">-->
          <!--<div class="icon-admin" @click="changeAccount(accountInfoVO,()=>{$router.push({path: '/viewIndex'})})" title="切换身份"><i class="icon icon-switchover"></i>切换</div>-->
          <!--<div class="icon-admin" @click="toMyYZ(accountInfoVO)" title="印章管理"><i class="icon icon-z"></i>印章</div>-->
          <!--<div class="icon-admin" @click="changeAccount(accountInfoVO,()=>{$router.push({path: '/tpl/general'})})" title="模板管理"><i class="icon icon-mb"></i>模板</div>-->
<!--&lt;!&ndash;          <div class="icon-admin" v-if="isShowNormalConsoleEntry" @click="changeAccount(accountInfoVO,()=>{$router.push('/console')})" title="企业设置"><i class="icon icon-setting"></i>设置</div>&ndash;&gt;-->
          <!--<div class="icon-admin" v-if="isShowNormalConsoleEntry" @click="handleConsoleClick(accountInfoVO)" title="企业设置"><i-->
            <!--class="icon icon-setting"></i>设置</div>-->
          <!--<div class="icon-admin" v-if="accountInfoVO.isUserInvite === 1" title="代理" @click="gotoJunziqianPrmLogin"><i class="icon icon-daili"></i>代理</div>-->
        <!--</span>-->
      <!--</div>-->
      <!--<div class="bottom">-->
        <!--<div class="sbox" @click="changeAccount(accountInfoVO,()=>{$router.push({path: '/signInfo/signList', query: {signStatus: 2}})})">-->
          <!--<div class="unfinish"></div>-->
          <!--<div class="cont">-->
            <!--<p>{{userInfo.signCount.noFinishCount || 0}}</p>-->
            <!--<p>未完成</p>-->
          <!--</div>-->
        <!--</div>-->
        <!--<div class="sbox" @click="changeAccount(accountInfoVO,()=>{$router.push({path: '/signInfo/signList', query: {signStatus: 3}})})">-->
          <!--<div class="finish"></div>-->
          <!--<div class="cont">-->
            <!--<p>{{userInfo.signCount.finishCount || 0}}</p>-->
            <!--<p>已结束</p>-->
          <!--</div>-->
        <!--</div>-->
        <!--<div class="sbox" @click="changeAccount(accountInfoVO,()=>{$router.push({path: '/signInfo/applyList', query: {signStatus: 4}})})">-->
          <!--<div class="draft"></div>-->
          <!--<div class="cont">-->
            <!--<p>{{userInfo.signCount.draftBoxCount || 0}}</p>-->
            <!--<p>草稿箱</p>-->
          <!--</div>-->
        <!--</div>-->
        <!--<template v-if="$store.getters.hasAuthUser">-->
          <!--<span class="solid"></span>-->
          <!--<div class="wj" v-if="$store.getters.authUser.userType === 1">-->
            <!--<p>套餐 (份)</p>-->
            <!--<p>{{userInfo.remainCnt}}</p>-->
          <!--</div>-->
          <!--<div class="wj">-->
            <!--<p>积分 (分)</p>-->
            <!--<p>{{userInfo.pointCnt}}</p>-->
          <!--</div>-->
        <!--</template>-->
      <!--</div>-->
    <!--</div>-->

    <!--&lt;!&ndash;    已加入企业&ndash;&gt;-->
    <!--<template v-for="(item,index) in allAuthUser.bindCorpUsers">-->
      <!--<div class="box-one joined" :key="'joined'+index" v-if="$store.getters.currentAuthUser &&-->
      <!--$store.getters.currentAuthUser.corpUserId!==item.corpUserId">-->
        <!--<div class="top">-->
          <!--<h1 class="com-title"><i></i>{{item.corpName}}<span><span class="icon el-icon-success"></span>已加入</span></h1>-->
          <!--<span style="display: flex; align-items: center; margin-left: 20px;">-->
          <!--<div class="icon-admin" @click="changeAccount(item,()=>{$router.push({path: '/viewIndex'})})" title="切换身份"><i class="icon icon-switchover"></i>切换</div>-->
          <!--<div class="icon-admin" @click="changeAccount(item,()=>{$router.push({path: '/tpl/corpSet'})})" title="印章管理"><i class="icon icon-z"></i>印章</div>-->
          <!--<div class="icon-admin" @click="changeAccount(item,()=>{$router.push({path: '/tpl/general'})})" title="模板管理"><i class="icon icon-mb"></i>模板</div>-->
          <!--<div class="icon-admin" v-if="item.superFlag == 1 || item.perms && item.perms.length>0" @click="changeAccount(item,()=>{$router.push('/console')})" title="企业设置">-->
            <!--<i class="icon icon-setting"></i>设置-->
          <!--</div>-->
        <!--</span>-->
        <!--</div>-->
        <!--<div class="bottom">-->
          <!--<div class="sbox" @click="changeAccount(item,()=>{$router.push({path: '/corp/signInfo/signList', query: {signStatus: 2}})})">-->
            <!--<div class="unfinish"></div>-->
            <!--<div class="cont">-->
              <!--<p>{{corpInfo.signCount[item.corpUserId] && corpInfo.signCount[item.corpUserId].noFinishCount || 0}}</p>-->
              <!--<p>未完成</p>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="sbox" @click="changeAccount(item,()=>{$router.push({path: '/corp/signInfo/signList', query: {signStatus: 3}})})">-->
            <!--<div class="finish"></div>-->
            <!--<div class="cont">-->
              <!--<p>{{corpInfo.signCount[item.corpUserId] && corpInfo.signCount[item.corpUserId].finishCount || 0}}</p>-->
              <!--<p>已结束</p>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="sbox" @click="changeAccount(item,()=>{$router.push({path: '/corp/signInfo/applyList', query: {signStatus: 4}})})">-->
            <!--<div class="draft"></div>-->
            <!--<div class="cont">-->
              <!--<p>{{corpInfo.signCount[item.corpUserId] && corpInfo.signCount[item.corpUserId].draftBoxCount || 0}}</p>-->
              <!--<p>草稿箱</p>-->
            <!--</div>-->
          <!--</div>-->
          <!--<span class="solid" v-if="$utils.isEmpty(corpInfo.remainCnt[item.corpUserId]) || $utils.isEmpty(corpInfo.pointCnt[item.corpUserId])"></span>-->
          <!--<div class="wj" v-if="$utils.isEmpty(corpInfo.remainCnt[item.corpUserId])">-->
            <!--<p>套餐 (份)</p>-->
            <!--<p>{{corpInfo.remainCnt[item.corpUserId]}}</p>-->
          <!--</div>-->
          <!--<div class="wj" v-if="$utils.isEmpty(corpInfo.pointCnt[item.corpUserId])">-->
            <!--<p>积分 (分)</p>-->
            <!--<p>{{corpInfo.pointCnt[item.corpUserId]}}</p>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    <!--</template>-->

    <!--&lt;!&ndash;    未加入企业&ndash;&gt;-->
    <!--<template v-for="(item,index) in allAuthUser.notBindCorpUsers">-->
      <!--<div class="box-one notJoined" :key="'notjoined'+index" v-loading="item.joinLoading">-->
        <!--<div class="top">-->
          <!--<h1 class="com-title"><i></i>{{item.corpName}}<span><span class="icon el-icon-success"></span>未加入</span></h1>-->
        <!--</div>-->
        <!--<div class="bottom">-->
          <!--<img src="/images/web/join.png"/>-->
          <!--<p>该企业邀请您成为企业成员，<a class="com-link" @click="joinThem(item)">立即加入>></a></p>-->
        <!--</div>-->
      <!--</div>-->
    <!--</template>-->

    <!--<div class="box-one bon">-->
      <!--<a :href="domain.junziqianApi + '/api_doc/index.html'" target="_blank"><i class="icon-w1"></i> 开发文档 >></a>-->
      <!--<a :href="domain.junziqianMain + '/file_query.html#fileVerification'" target="_blank"><i class="icon-w1"></i>如何验证已签署合同的有效性 >></a>-->
      <!--<a :href="domain.junziqianMain + '/help.html#hisProblem'" target="_blank"><i class="icon-w1"></i>如何处理已签署合同发生的纠纷 >></a>-->
    <!--</div>-->
    <!--&lt;!&ndash;-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; 20200811改版end -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->

    <!--<el-dialog title="添加集团账户电子签署系统" :visible.sync="createCorpShow" :close-on-click-modal="false" width="30%"-->
               <!--class="dialog">-->
      <!--<el-form :model="createCorpInfo" ref="createCorpForm">-->
        <!--<el-form-item label="集团名称">-->
          <!--<el-input-->
            <!--v-model="createCorpInfo.name"-->
            <!--autocomplete="off"-->
            <!--placeholder="50字以内，可不填"-->
            <!--maxlength="50"-->
            <!--:clearable="true"></el-input>-->
        <!--</el-form-item>-->
      <!--</el-form>-->
      <!--<div slot="footer" class="dialog-footer">-->
        <!--<el-button @click="createCorpShow = false">取 消</el-button>-->
        <!--<el-button type="primary" @click="handleCreateCorp">确 定</el-button>-->
      <!--</div>-->
    <!--</el-dialog>-->
  <!--</div>-->
<!--</template>-->

<!--<script>-->
  <!--import Cell from "@/components/cell/index";-->
  <!--import ImgAuth from '@/components/img-auth/img-auth';-->
  <!--import PublishSign from "@/components/publish-sign/index";-->
  <!--import FileSignCreate from "@/components/file-sign-create/index";-->
  <!--import {-->
    <!--ApiCorpMethods,-->
    <!--postSignPage,-->
    <!--postSignCont as corp_postSignCont,-->
    <!--signViewUrl,-->
    <!--signAudit-->
  <!--} from "@/assets/js/http-serve/corp/http-methods";-->
  <!--import {ApiMethods, applyViewUrl, configUrl, fileOperShow,postSignCont,acceptInvitePc} from '@/assets/js/http-serve/http-methods';-->
  <!--import {email, mobile, imgAuth} from '@/assets/js/lib/valid-methods';-->
  <!--import GlobalConfig from '@/assets/js/config/global'-->
  <!--import CorpHandles from '@/components/apply-list/corpHandles'-->
	<!--import CorpApplyName from '@/components/apply-list/corpContractName'-->
	<!--import RealNameAuthentication from '@/components/real-name-authentication'-->
	<!--import GuideView from '@/components/guide-view/Index'-->
  <!--import {consoleProfile, getCorpToken, loginOrRefresh, setCurrentUser, storeAllToken} from '../../assets/js/http-serve/corp/common';-->
  <!--export default {-->
    <!--data() {-->
      <!--return {-->
				<!--// 新手指引-->
				<!--visibleGuideView: false,-->
				<!--// 实名认证信息-->
				<!--visibleIdentity: false,-->
				<!--identityInfo: undefined,-->
        <!--// 域名-->
        <!--domain: GlobalConfig.domain,-->
        <!--fileList: null,-->
        <!--dialogVisible: false,-->
        <!--loading: null,-->
        <!--signCount: {-->
          <!--noFinishCount:'-',-->
          <!--finishCount:'-',-->
          <!--draftBoxCount:'-'-->
        <!--},-->
        <!--// 集团用户邀请管理员-->
        <!--inviteAdmin: {-->
          <!--username: '',-->
          <!--realName: '',-->
          <!--mobilePhoneNo: '',-->
          <!--imgCode: '',-->
          <!--sourceTagId: '',-->
          <!--imgToken: '',-->
          <!--imgText: ''-->
        <!--},-->
        <!--rules: {-->
          <!--username: [{validator: email, target: 'blur'}],-->
          <!--mobilePhoneNo: [{validator: mobile, target: 'blur'}],-->
          <!--imgText: [{validator: imgAuth, target: 'blur'}]-->
        <!--},-->
        <!--userPointCnt: 0,-->
        <!--remainCnt: 0,-->
        <!--fileOperShow: fileOperShow,-->
        <!--// 视频播放地址-->
        <!--videoSrc:'',-->
        <!--videoSrc1:'http://vod.junziqian.com/0ab320a16e4946e89d9a0b1ce242cf14/195260b6d12745fb9151fd1b0bc1c1de-bca264c1013e96ef2ba66238551a3926-ld.mp4', // 一分钟短视频-->
        <!--videoSrc2:'http://vod.junziqian.com/0ab320a16e4946e89d9a0b1ce242cf14/195260b6d12745fb9151fd1b0bc1c1de-bca264c1013e96ef2ba66238551a3926-ld.mp4', // 三分钟短视频-->
        <!--// 加入的企业-->
        <!--corpInfo:{-->
          <!--signCount:{}, // 加入企业的已完成，未完成，草稿箱数量-->
          <!--pointCnt:{}, // 加入企业的积分-->
          <!--remainCnt:{} // 套餐剩余数-->
        <!--},-->
        <!--// 登录账户的信息-另外一个接口查询-->
        <!--userInfo:{-->
          <!--signCount:{},-->
          <!--pointCnt:'', // 积分-->
          <!--remainCnt:''-->
        <!--},-->
        <!--// 202200927更改，将原来default中“是否显示创建集团系统”代码逻辑移植到当前页-->
        <!--createCorpShow: false, //是否显示创建集团系统-->
        <!--createCorpInfo: {},-->
      <!--}-->
    <!--},-->
    <!--async beforeMount() {-->
      <!--this.loading = this.$loading({-->
        <!--lock: true,-->
      <!--});-->
      <!--//判断是否切换首页-->
      <!--let isStop = this.changePageByCurrentUserOnce(this.$store.getters.currentAuthUser)-->
      <!--if(isStop) return false // 跳转后不请求后面的其他接口-->
      <!--this.getUserPointCnt();-->
      <!--// 获取套餐剩余-->
      <!--this.getSignPlusCnt()-->

      <!--// ****************20200811 sass大改需求，新增查询加入企业的信息功能start****************-->
      <!--/**-->
       <!--*  20200811 sass大改需求，新增查询加入企业的信息功能-->
       <!--* */-->
      <!--// 存储所有token,更新时间：每次进入首页-->
      <!--storeAllToken((res)=>{-->
        <!--this.searchCorpInfo(res)-->
      <!--})-->

      <!--// 查询登录账户的信息-->
      <!--postSignCont().then(({data}) => {-->
        <!--this.userInfo.signCount = data;-->
      <!--});-->

      <!--if (this.allAuthUser.accountInfoVO && this.allAuthUser.accountInfoVO.userType === 0) {-->
        <!--// 个人用户、或者未获取到用户类型，不显示套餐数-->
      <!--} else {-->
        <!--// 企业用户，显示套餐-->
        <!--// 查询登录账户套餐剩余数-->
        <!--ApiMethods.ProfileController.signSurplusCount().then((res)=>{-->
          <!--if (res.success && res.data) {-->
            <!--this.userInfo.remainCnt = res.data.remainCnt;-->
          <!--} else {-->
            <!--this.$message.error(res.description || this.$tip);-->
          <!--}-->
        <!--});-->
      <!--}-->

      <!--// 查询登录账户积分-->
      <!--ApiMethods.ProfileController.userPoint({}).then(result => {-->
        <!--if (result.success) {-->
          <!--this.userInfo.pointCnt = result.data;-->
        <!--} else {-->
          <!--this.$message.error(result.description || this.$tip);-->
        <!--}-->
      <!--});-->
      <!--// ****************20200811 sass大改需求，新增查询加入企业的信息功能end****************-->


      <!--// *****************之前mounted里面的方法start*****************-->
      <!--// 获取当前切换账户的信息-->
      <!--postSignPage({itemPage: 0, pageSize: 5, signStatus: 0, searchType: 1}).then(res => {-->
        <!--this.fileList = res.data;-->
      <!--});-->
      <!--corp_postSignCont().then(({data}) => {-->
        <!--console.log(data, 6666)-->
        <!--this.signCount = data;-->
      <!--});-->
      <!--this.loading.close();-->

      <!--if (this.$store.getters.allAuthUser && this.$store.getters.allAuthUser.accountInfoVO && this.$store.getters.allAuthUser.accountInfoVO.identityAuth === 1) {-->
        <!--this.getAuthCerti()-->
      <!--}-->
      <!--// *****************之前mounted里面的方法end*****************-->
    <!--},-->
    <!--mounted() {-->
    <!--},-->
    <!--methods: {-->
      <!--gotoJunziqianPrmLogin(){-->
        <!--window.open(this.globalConfig.domain.junziqianPrmLogin, "_blank")-->
      <!--},-->
			<!--openVisibleIdentity() {-->
				<!--if (this.identityInfo !== undefined) {-->
					<!--this.visibleIdentity = true-->
				<!--}-->
			<!--},-->
			<!--// 获取身份认证信息-->
			<!--getAuthCerti() {-->
				<!--ApiMethods.IdenAuthController.authCerti().then(res => {-->
					<!--if (res.code === '0') {-->
						<!--this.identityInfo = res.data-->
					<!--}-->
				<!--})-->
			<!--},-->
      <!--// gotoEnd-->
      <!--gotoEnd() {-->
        <!--const url = this.globalConfig.domain.junziqianMain + '/groupAccounts.html'-->
        <!--window.open(url)-->
      <!--},-->
      <!--//根据当前切换的用户，切换首页-->
      <!--changePageByCurrentUserOnce(currentUser) {-->

        <!--try {-->
          <!--if (currentUser.userType == 0 || currentUser.userType == 1) {-->
            <!--this.$router.push('/viewIndex');-->
            <!--return true-->
          <!--}-->
        <!--} catch (e) {-->
          <!--console.log(e);-->
        <!--}-->
        <!--return false-->
      <!--},-->
      <!--toByPoint() {-->
        <!--window.open(configUrl().accountWeb + '/asset/point', '_blank');-->
      <!--},-->
      <!--// 查询父企业的积分-->
      <!--async getUserPointCnt() {-->
        <!--let res = await ApiCorpMethods.ProfileController.userPoint();-->
        <!--if (res.success) {-->
          <!--this.userPointCnt = res.data;-->
        <!--} else {-->
          <!--this.$message.error(res.description || this.$tip);-->
        <!--}-->
      <!--},-->
      <!--// 查询父企业的套餐剩余数-->
      <!--async getSignPlusCnt() {-->
        <!--let res = await ApiCorpMethods.ProfileController.signSurplusCount();-->
        <!--if (res.success && res.data && res.data.remainCnt) {-->
          <!--this.remainCnt = res.data.remainCnt-->
        <!--} else {-->
        <!--}-->
      <!--},-->
      <!--// ***************************20200811大改 start***************************-->
      <!--/**-->
       <!--*  查询加入的集团用户积分套餐签署数等信息-->
       <!--*  @corpUserId corpUserId 当前集团账号的corpUserId-->
       <!--*  @token token 当前集团账号的token-->
       <!--* */-->
      <!--searchCorpInfo({corpUserId,token}){-->
        <!--let res = {corpUserId,token}-->
        <!--// 查询父企业信息-->
        <!--corp_postSignCont({_ctToken:res.token}).then((result) => {-->
          <!--// console.log(res,result, 'ddddddddddd')-->
          <!--if(result && result.data){-->
            <!--// this.corpInfo.signCount[res.corpUserId] = result.data-->
            <!--this.$set(this.corpInfo.signCount,res.corpUserId,result.data)-->
          <!--}else {-->
            <!--this.$message.error(result.description || this.$tip);-->
          <!--}-->
        <!--});-->

        <!--// 查询父企业的积分-->
        <!--ApiCorpMethods.ProfileController.userPoint({_ctToken:res.token}).then((result)=>{-->
          <!--if (result.success) {-->
            <!--// this.corpInfo.pointCnt[res.corpUserId] = result.data-->
            <!--this.$set(this.corpInfo.pointCnt,res.corpUserId,result.data)-->
          <!--} else {-->
            <!--this.$message.error(result.description || this.$tip);-->
          <!--}-->
        <!--});-->

        <!--// 查询父企业的套餐剩余数-->
        <!--ApiCorpMethods.ProfileController.signSurplusCount({_ctToken:res.token}).then((result)=>{-->
          <!--if (result.success && result.data) {-->
            <!--// this.corpInfo.remainCnt[res.corpUserId] = result.data.remainCnt-->
            <!--this.$set(this.corpInfo.remainCnt,res.corpUserId,result.data.remainCnt)-->
          <!--} else {-->
            <!--this.$message.error(result.description || this.$tip);-->
          <!--}-->
        <!--});-->
      <!--},-->
      <!--// 切换用户-->
      <!--changeAccount(user,callback) {-->
        <!--console.log('切换信息',user)-->
        <!--this.$store.dispatch('setIgnoreChangePage',true) // 关闭切换重定向-->
        <!--setCurrentUser(user).finally(()=>{-->
          <!--callback && (this.$store.dispatch('setIgnoreChangePage',false), callback());-->
        <!--});-->
      <!--},-->
      <!--// 加入企业-->
      <!--joinThem(item){-->
        <!--this.$set(item,'joinLoading',true)-->
        <!--item.inviteInfo && acceptInvitePc(item.inviteInfo).then((res)=>{-->
          <!--if(res && res.success){-->
            <!--// 集团信息变化-更新store-->
            <!--consoleProfile()-->
            <!--// 存储当前企业token-->
            <!--getCorpToken(item.corpUserId).then((result)=>{-->
              <!--if(result && result.data){-->
                <!--item.joinLoading = false-->
                <!--// 查询其相关信息-->
                <!--this.searchCorpInfo({corpUserId:item.corpUserId,token:result.data})-->
              <!--}-->
            <!--})-->
          <!--}-->
        <!--})-->
      <!--},-->
      <!--toMyYZ(info){-->
        <!--this.changeAccount(info,()=>{-->
          <!--if(info.userType == 0){ // 个人-->
            <!--this.$router.push({path: '/tpl/personSet'})-->
          <!--} else { // 企业 userType == 1-->
            <!--this.$router.push({path: '/tpl/entSign'})-->
          <!--}-->
        <!--})-->
      <!--},-->
      <!--// ***************************20200811大改 end***************************-->
      <!--async handleConsoleClick(accountInfoVO) {-->

        <!--let goConsole =()=>{-->
          <!--this.changeAccount(accountInfoVO,()=>{this.$router.push('/console')})-->
        <!--}-->

        <!--let allUser = this.$store.getters.allAuthUser;-->
        <!--//判断是不是普通账号（超级管理员绑定在普通账号）-->
          <!--if (allUser) {-->
            <!--if (allUser.accountInfoVO.userType == 0 || allUser.accountInfoVO.userType == 1) {-->
              <!--// 可创建-->
              <!--if (allUser.corpCreateFlag == 1) {-->
                <!--// 未创建-->
                <!--if (!(allUser.manCorpUser && allUser.manCorpUser.corpUserId)) {-->
                  <!--// 显示创建-->
                  <!--this.createCorpShow = true;-->
                  <!--return-->
                <!--}-->
                <!--// 已创建-->
                <!--else {-->
                  <!--// 直接进入集团控制台-->
                  <!--return goConsole()-->
                <!--}-->
              <!--}-->
              <!--// // 其他情况，显示集团控制台开通方式-->
              <!--// else {-->
              <!--//   this.gotoEnd();-->
              <!--// }-->
            <!--}-->
          <!--}-->

        <!--return goConsole()-->
      <!--},-->
      <!--handleCreateCorp() {-->
        <!--//创建组织-->
        <!--let corpName = this.createCorpInfo.name;-->
        <!--ApiCorpMethods.CorpController.createCorp(corpName).then(res => {-->
          <!--if (res.success) {-->
            <!--loginOrRefresh().then((refreshRes) => {-->
              <!--if (!refreshRes.success) {-->
                <!--window.location.reload();-->
              <!--}-->
            <!--}).catch(() => {-->
            <!--});-->
            <!--this.$confirm(`${res.description || '创建集团系统成功'}，立即进入控制台？`, '系统提示', {-->
              <!--showConfirmButton: true,-->
              <!--showCancelButton: true,-->
              <!--type: 'info',-->
            <!--}).then(() => {-->
              <!--// this.$router.push('/console');-->
              <!--this.changeAccount(this.accountInfoVO,()=>{this.$router.push('/console')})-->
            <!--}).catch(async () => {-->
              <!--this.$message({-->
                <!--message: res.description || '创建集团系统成功',-->
              <!--});-->
              <!--let refreshRes = await loginOrRefresh();-->
              <!--if (!refreshRes.success) {-->
                <!--window.location.reload();-->
              <!--}-->
              <!--this.createCorpShow = false;-->
              <!--this.createCorpInfo.name = '';-->
            <!--});-->
          <!--} else {-->
            <!--this.$message.error(res.description || '创建集团系统失败');-->
          <!--}-->
          <!--this.createCorpShow = false;-->
          <!--this.createCorpInfo.name = '';-->
        <!--}).catch(err => {-->
          <!--this.createCorpShow = false;-->
          <!--this.createCorpInfo.name = '';-->
          <!--console.log(err);-->
        <!--});-->
      <!--},-->
    <!--},-->
    <!--name: "index",-->
    <!--components: {PublishSign, Cell, ImgAuth, FileSignCreate, CorpHandles, CorpApplyName, RealNameAuthentication, GuideView},-->
    <!--computed: {-->
      <!--accountInfoVO() {-->
        <!--if (this.$store.getters.allAuthUser && this.$store.getters.allAuthUser.accountInfoVO) {-->
          <!--return this.$store.getters.allAuthUser.accountInfoVO;-->
        <!--}-->
        <!--return {};-->
      <!--},-->
      <!--corpUser() {-->
        <!--return `${this.$store.getters.currentAuthUser.corpName || ''} - ${this.$store.getters.currentAuthUser.userName || ''}`-->
      <!--},-->
      <!--departmentInfo(){-->
        <!--try {-->
          <!--return `${this.$store.getters.currentAuthUser.groupFullName}`-->
        <!--}catch (e) {-->
          <!--return ''-->
        <!--}-->
      <!--},-->
      <!--avatar(){-->
        <!--try{-->
          <!--return this.fileOperShow(this.$store.getters.currentAuthUser.imgPath || '').toString()-->
        <!--}catch (e) {-->
          <!--return ''-->
        <!--}-->
      <!--},-->
      <!--/**-->
       <!--* 集团用户判断是否显示企业控制台按钮-->
       <!--* @returns {boolean}-->
       <!--*/-->
      <!--isShowConsoleEntry() {-->
        <!--try {-->
          <!--//管理员，显示控制台按钮-->
          <!--if (this.$store.getters.currentAuthUser.superFlag == 1) {-->
            <!--return true;-->
          <!--}-->
          <!--//无法获取当前用户，不显示控制台按钮-->
          <!--if (!this.$store.getters.currentAuthUser) {-->
            <!--return false;-->
          <!--}-->
          <!--//当前用户的consoleToken中，perms有值，则显示控制台按钮-->
          <!--if (this.$store.getters.consoleToken && this.$store.getters.consoleToken.perms && this.$store.getters.consoleToken.perms.length > 0) {-->
            <!--// 判断是否有权限-->
            <!--if (this.$store.getters.consoleToken.perms[0]) {-->
              <!--return true;-->
            <!--} else {-->
              <!--return false;-->
            <!--}-->
          <!--}-->
          <!--return false;-->

        <!--} catch (e) {-->
          <!--console.log(e);-->
        <!--}-->
      <!--},-->
      <!--/**-->
       <!--* 普通用户判断是否显示企业控制台按钮-->
       <!--* @returns {boolean}-->
       <!--*/-->
      <!--isShowNormalConsoleEntry() {-->
        <!--try {-->
          <!--//超级管理员-->
          <!--if (this.$store.getters.allAuthUser && this.$store.getters.allAuthUser.corpCreateFlag == 1) {-->
            <!--return true;-->
          <!--}-->
          <!--// 企业用户，统统显示-->
          <!--if (this.$store.getters.allAuthUser && this.$store.getters.allAuthUser.accountInfoVO && this.$store.getters.allAuthUser.accountInfoVO.userType === 1) {-->
            <!--return true;-->
          <!--}-->
          <!--return false;-->
        <!--} catch (e) {-->
          <!--console.log(e);-->
        <!--}-->
      <!--},-->
      <!--allAuthUser(){-->
        <!--return this.$store.getters.allAuthUser || {}-->
      <!--}-->
    <!--},-->
    <!--filters: {-->
      <!--lessThan(val,length) {-->
        <!--if (val.length >= length) {-->
          <!--return val.slice(0, 15) + '...'-->
        <!--}-->
        <!--return val-->
      <!--}-->
    <!--},-->
    <!--head() {-->
      <!--return {-->
        <!--title: '我的首页'-->
      <!--}-->
    <!--}-->
  <!--}-->
<!--</script>-->

<!--<style lang="less" scoped>-->
  <!--.operation span {-->
    <!--display: inline-block;-->
    <!--margin-right: 10px;-->
    <!--cursor: pointer;-->
  <!--}-->

  <!--.add-child {-->
    <!--width: 80%;-->
    <!--margin: 0 auto;-->

    <!--.btn {-->
      <!--width: 120px;-->
    <!--}-->

    <!--.img-auth {-->
      <!--width: 70%;-->

      <!--span {-->
        <!--display: inline-block;-->
        <!--width: 90px;-->
        <!--height: 30px;-->
        <!--margin: 0 -20px;-->
        <!--cursor: pointer;-->
      <!--}-->
    <!--}-->
  <!--}-->

  <!--.latest {-->
    <!--margin-top: 15px;-->
    <!--padding: 17px 15px;-->
    <!--background-color: #ffffff;-->
    <!--.header {-->
      <!--padding-bottom: 14px;-->
      <!--margin-bottom: 15px;-->
      <!--border-bottom: solid 1px #E6E6E6;-->
      <!--.title {-->
        <!--font-size: 16px;-->
        <!--color: #353535;-->
        <!--font-weight: 600;-->
      <!--}-->
    <!--}-->
    <!--.btn-more {-->
      <!--text-align: center;-->
      <!--padding: 30px 0 20px 0;-->
      <!--// border: 1px solid #ebebeb;-->
      <!--border-top: none;-->
      <!--.btn:hover {-->
        <!--background: #ec1c1c;-->
        <!--border: #ec1c1c;-->
        <!--color: #ffffff;-->
        <!--opacity: .75;-->
      <!--}-->
    <!--}-->
    <!--.table {-->
      <!--width: 100%;-->
      <!--border: 1px solid #ebebeb;-->
      <!--border-bottom: none;-->
      <!--color: #333;-->
      <!--.operation > span {-->
        <!--cursor: pointer;-->
      <!--}-->
    <!--}-->
    <!--h5 {-->
      <!--margin: 40px 0 10px 0;-->
      <!--font-size: 12px;-->
      <!--font-weight: 500;-->
      <!--color: #333333;-->
    <!--}-->
  <!--}-->

  <!--.product-assist {-->
    <!--margin-top: 15px;-->
    <!--margin-bottom: 20px;-->
    <!--.el-col {-->
      <!--&:first-child {-->
        <!--a {-->
          <!--margin-left: 0;-->
        <!--}-->
      <!--}-->
      <!--&:hover {-->
        <!--a {-->
          <!--border: solid 1px #EC1C1C;-->
          <!--height: 62px;-->
          <!--line-height: 62px;-->
        <!--}-->
      <!--}-->
    <!--}-->
    <!--a {-->
      <!--height: 64px;-->
      <!--line-height: 64px;-->
      <!--margin-left: 15px;-->
      <!--background-color: #ffffff;-->
      <!--display: block;-->
      <!--text-align: center;-->
      <!--white-space: nowrap;-->
      <!--overflow-x: hidden;-->
      <!--text-overflow: ellipsis;-->
      <!--.icon {-->
        <!--margin-right: 10px;-->
      <!--}-->
    <!--}-->
  <!--}-->

  <!--.totals-sign {-->
    <!--margin-top: 15px;-->
    <!--border-top: 0;-->
    <!--text-align: center;-->
    <!--border: none;-->
    <!--.sign-count {-->
      <!--padding: 40px 50px 39px 50px;-->
      <!--margin-right: 15px;-->
      <!--background-color: #fff;-->
    <!--}-->
    <!--.signed {-->
      <!--padding: 21px 40px 21px 40px;-->
      <!--background-color: #ffffff;-->
      <!--.line-head {-->
        <!--line-height: 2;-->
        <!--&:after {-->
          <!--display: block;-->
          <!--content: '';-->
          <!--clear: both;-->
        <!--}-->
      <!--}-->
    <!--}-->
    <!--.item {-->
      <!--width: 120px;-->
      <!--padding: 20px 0;-->
      <!--margin: 0 auto;-->
      <!--border-radius: 2px;-->
      <!--cursor: pointer;-->
      <!--&:hover {-->
        <!--box-shadow: 0 0 4px 2px #f1f1f1;-->
      <!--}-->
      <!--img {-->
        <!--height: 60px;-->
        <!--border-radius: 50%;-->
      <!--}-->
      <!--p {-->
        <!--font-size: 14px;-->
        <!--color: #9A9A9A;-->
        <!--&.count-num {-->
          <!--margin: 26px 0 18px 0;-->
          <!--font-size: 24px;-->
          <!--color: #646464;-->
        <!--}-->
      <!--}-->
    <!--}-->
  <!--}-->

  <!--.n-user {-->
    <!--white-space: nowrap;-->
    <!--height: 140px;-->
    <!--padding: 20px 43px 25px 43px;-->
    <!--background-color: #ffffff;-->
    <!--.user-point {-->
      <!--height: 94px;-->
      <!--float: right;-->
      <!--line-height: 18px;-->
      <!--.file-count {-->
        <!--float: left;-->
        <!--padding: 0 38px;-->
        <!--border-right: 1px solid #D8D8D8;-->
        <!--.icon-tongji {-->
          <!--vertical-align: middle;-->
          <!--margin-left: 0;-->
        <!--}-->
      <!--}-->
      <!--.point-count {-->
        <!--float: left;-->
        <!--padding-left: 38px;-->
      <!--}-->
      <!--.title {-->
        <!--font-size: 12px;-->
        <!--color: #9A9A9A;-->
        <!--text-align: left;-->
        <!--i {-->
          <!--margin-left: 5px;-->
        <!--}-->
      <!--}-->
      <!--p {-->
        <!--line-height: 30px;-->
        <!--margin-top: 1px;-->
      <!--}-->
      <!--a {-->
        <!--i {-->
          <!--display: inline-block;-->
          <!--height: 18px;-->
          <!--width: 18px;-->
          <!--margin-left: 20px;-->
          <!--margin-right: 5px;-->
          <!--background-size: contain;-->
          <!--vertical-align: bottom;-->
        <!--}-->
      <!--}-->
      <!--.icon-shoppingcar {-->
        <!--margin-left: 0;-->
        <!--vertical-align: middle;-->
        <!--background: url(/images/icon/icon_gwc.png) no-repeat center;-->
      <!--}-->
      <!--.purchase {-->
      <!--}-->
    <!--}-->
    <!--.signed {-->
      <!--padding: 21px 40px 21px 40px;-->
      <!--background-color: #ffffff;-->
      <!--.line-head {-->
        <!--line-height: 2;-->
        <!--&:after {-->
          <!--display: block;-->
          <!--content: '';-->
          <!--clear: both;-->
        <!--}-->
      <!--}-->
    <!--}-->
    <!--.user-box {-->
      <!--position: relative;-->
      <!--float: left;-->
      <!--height: 94px;-->
      <!--.user-info {-->
        <!--width: 70%;-->
        <!--margin-left: 33px;-->
        <!--.sfrz {-->
          <!--margin-left: 12px;-->
          <!--color: #999;-->
          <!--.icon {-->
            <!--width: 19px;-->
            <!--height: 20px;-->
            <!--color: #999;-->
            <!--vertical-align: middle;-->
            <!--background: url('/images/icon/icon_sfrz.png');-->
            <!--background-size: cover;-->
          <!--}-->
        <!--}-->
        <!--.link-btn {-->
          <!--.icon {-->
            <!--margin-right: 16px;-->
          <!--}-->
          <!--/deep/ .cell {-->
            <!--color: #676767;-->
            <!--cursor: pointer;-->
            <!--padding: 0;-->
            <!--&:hover {-->
              <!--text-decoration: underline;-->
            <!--}-->
          <!--}-->
        <!--}-->
        <!--p {-->
          <!--white-space: nowrap;-->
          <!--overflow: hidden;-->
          <!--text-overflow: ellipsis;-->
          <!--line-height: 28px;-->
          <!--margin-top: 1px;-->
        <!--}-->
        <!--.auth-icon {-->
          <!--position: relative;-->
          <!--display: inline-block;-->
          <!--padding: 0 4px 0 17px;-->
          <!--border-style: solid;-->
          <!--border-width: 1px;-->
          <!--line-height: 14px;-->
          <!--height: 14px;-->
          <!--font-size: 12px;-->
          <!--border-top-left-radius: 8px;-->
          <!--border-bottom-left-radius: 8px;-->
          <!--border-top-right-radius: 8px;-->
          <!--border-bottom-right-radius: 8px;-->
          <!--i {-->
            <!--position: absolute;-->
            <!--left: 1px;-->
            <!--top: 50%;-->
            <!--margin-top: -7px;-->
            <!--font-size: 14px;-->
            <!--vertical-align: middle;-->
          <!--}-->
          <!--&.auth-did {-->
						<!--color: #ec1c1c;-->
          <!--}-->
          <!--&.auth-not {-->
            <!--color: #989898;-->
          <!--}-->
        <!--}-->

        <!--p > span {-->
          <!--/* cursor: pointer;*/-->
        <!--}-->
      <!--}-->
      <!--.user-photo {-->
        <!--position: relative;-->
        <!--height: 100%;-->
        <!--margin-right: 10px;-->
        <!--img {-->
          <!--height: 100%;-->
          <!--border-radius: 50%;-->
          <!--border: solid 1px #efefef;-->
        <!--}-->
      <!--}-->
    <!--}-->
  <!--}-->

  <!--.box-one{-->
    <!--background:rgba(255,255,255,1);-->
    <!--box-shadow:0px 2px 8px rgba(0,0,0,0.1);-->
    <!--border-radius:10px;-->
    <!--margin-bottom: 20px;-->
    <!--box-sizing: border-box;-->
    <!--color: #290202;-->
    <!--.top{-->
      <!--box-sizing: border-box;-->
      <!--padding-right: 30px;-->
      <!--height: 50px;-->
      <!--line-height: 50px;-->
      <!--display: flex;-->
      <!--/*justify-content: space-between;*/-->
      <!--align-items: center;-->
      <!--border-bottom: 1px solid #EBEBEB;-->
      <!--.com-w-btn{-->
        <!--margin-right: 29px;-->
        <!--&:last-child{-->
          <!--margin-right: 0;-->
        <!--}-->
      <!--}-->
      <!--span{-->
        <!--font-size: 14px;-->
      <!--}-->
      <!--.icon{-->
        <!--font-size: 20px;-->
        <!--margin-left: 10px;-->
        <!--margin-right: 5px;-->
      <!--}-->
    <!--}-->
    <!--.icon-admin {-->
      <!--height: 20px;-->
      <!--display: flex;-->
      <!--align-items: center;-->
      <!--color: rgba(41,2,2,1);-->
      <!--cursor: pointer;-->

      <!--&:hover {-->
        <!--color: #Ec1C1C;-->
      <!--}-->
    <!--}-->
  <!--}-->
  <!--.joined{-->
    <!--.com-title{-->
      <!--span{-->
        <!--color: #00cb14;-->
      <!--}-->
      <!--.icon{-->
        <!--color: #00cb14;-->
      <!--}-->
    <!--}-->
    <!--.bottom{-->
      <!--padding: 30px 20px;-->
      <!--box-sizing: border-box;-->
      <!--display: flex;-->
      <!--justify-content: space-between;-->
      <!--align-items: center;-->
      <!--.solid{-->
        <!--width: 1px;-->
        <!--height: 50px;-->
        <!--background:rgba(238,238,238,1);-->
        <!--display: inline-block;-->
      <!--}-->
    <!--}-->
  <!--}-->
  <!--.notJoined{-->
    <!--.com-title{-->
      <!--span{-->
        <!--color:rgba(183,183,183,1);-->
      <!--}-->
      <!--.icon{-->
        <!--color: #b7b7b7;-->
      <!--}-->
    <!--}-->
    <!--.bottom{-->
      <!--text-align: center;-->
      <!--padding-bottom: 36px;-->
      <!--img{-->
        <!--width: 100px;-->
        <!--min-height: 56px;-->
        <!--display: block;-->
        <!--margin: 32px auto 4px auto;-->
      <!--}-->
    <!--}-->
  <!--}-->
  <!--.om{-->
    <!--.top{-->
      <!--height: 90px;-->
      <!--padding: 0 30px 0 35px;-->
    <!--}-->
    <!--.t-left{-->
      <!--height: 100%;-->
      <!--display: flex;-->
      <!--justify-content: space-between;-->
      <!--align-items: center;-->
      <!--.portrait{-->
        <!--position: relative;-->
        <!--margin-right: 20px;-->
        <!--color: #00cb14;-->
        <!--font-size: 20px;-->
        <!--/*cursor: pointer;*/-->
        <!--i{-->
          <!--position: absolute;-->
          <!--bottom: 0;-->
          <!--right: 0;-->
          <!--width: 20px;-->
          <!--height: 20px;-->
        <!--}-->
        <!--img{-->
          <!--width: 65px;-->
          <!--height: 65px;-->
          <!--border-radius: 50%;-->
        <!--}-->
      <!--}-->
      <!--.un{-->
        <!--height: 100%;-->
        <!--box-sizing: border-box;-->
        <!--padding-top: 20px;-->
        <!--display: flex;-->
        <!--justify-content: space-between;-->
        <!--align-items: flex-start;-->
        <!--span{-->
          <!--font-size: 12px;-->
          <!--border-radius:19px;-->
          <!--display: inline-block;-->
          <!--height: 20px;-->
          <!--line-height: 20px;-->
          <!--padding: 0 5px;-->
          <!--color: #B7B7B7;-->
          <!--border: 1px solid #B7B7B7;-->
          <!--/*cursor: pointer;*/-->
          <!--&.y{-->
            <!--color: #EC1C1C;-->
            <!--border: 1px solid #EC1C1C;-->
            <!--&:hover{-->
              <!--color: #ffffff;-->
              <!--background: #EC1C1C;-->
            <!--}-->
          <!--}-->
          <!--&.m {-->
            <!--color: #00CB14;-->
            <!--border: 1px solid #00CB14;-->
          <!--}-->
        <!--}-->
        <!--p{-->
          <!--margin-bottom: 9px;-->
          <!--line-height: initial;-->
        <!--}-->
        <!--.icon-admin {-->
          <!--height: 20px;-->
          <!--display: flex;-->
          <!--align-items: center;-->
          <!--color: rgba(41,2,2,1);-->
          <!--cursor: pointer;-->

          <!--&:hover {-->
            <!--color: #Ec1C1C;-->
          <!--}-->
        <!--}-->
      <!--}-->
    <!--}-->
    <!--.t-right{-->
      <!--color:rgba(41,2,2,0.65);-->
      <!--.ft{-->
        <!--color:rgba(41,2,2,1);-->
        <!--margin-right: 29px;-->
      <!--}-->
    <!--}-->

    <!--.bottom{-->
      <!--box-sizing: border-box;-->
      <!--padding: 0 30px 36px 20px;-->
      <!--h1{-->
        <!--margin-top: 32px;-->
        <!--margin-bottom: 22px;-->
        <!--text-align: right;-->
        <!--span{-->
          <!--font-size:14px;-->
          <!--font-family:Source Han Sans SC;-->
          <!--font-weight:300;-->
          <!--color:rgba(41,2,2,1);-->
          <!--cursor: pointer;-->
          <!--&:hover{-->
            <!--color:rgba(236,28,28,1);-->
            <!--.icon{-->
              <!--background: url("/images/web/icon-play-on.png") no-repeat center;-->
              <!--background-size: auto 100%;-->
            <!--}-->
          <!--}-->
        <!--}-->
        <!--.icon{-->
          <!--width: 12px;-->
          <!--height: 12px;-->
          <!--margin-left: 5px;-->
          <!--vertical-align: middle;-->
        <!--}-->
      <!--}-->
      <!--.con{-->
        <!--display: flex;-->
        <!--justify-content: space-between;-->
        <!--align-items: center;-->
      <!--}-->
      <!--.brp{-->
        <!--display: flex;-->
        <!--justify-content: space-between;-->
        <!--align-items: center;-->
      <!--}-->
    <!--}-->
  <!--}-->

  <!--.sbox{-->
    <!--/*flex: none;*/-->
    <!--cursor: pointer;-->
    <!--width: 200px;-->
    <!--height: 160px;-->
    <!--margin-right: 20px;-->
    <!--text-align: center;-->
    <!--display: flex;-->
    <!--align-items: center;-->
    <!--justify-content: center;-->

    <!--.unfinish,.finish,.draft {-->
      <!--width: 60px;-->
      <!--height: 60px;-->
      <!--margin-right: 10px;-->
    <!--}-->
    <!--.unfinish {-->
      <!--background: url("../../static/images/web/unfinish.png") no-repeat;-->
      <!--background-size: cover;-->
    <!--}-->
    <!--.finish {-->
      <!--background: url("../../static/images/web/finish.png") no-repeat;-->
      <!--background-size: cover;-->
    <!--}-->
    <!--.draft {-->
      <!--background: url("../../static/images/web/draft.png") no-repeat;-->
      <!--background-size: cover;-->
    <!--}-->
    <!--.cont {-->
      <!--height: 100%;-->
    <!--}-->
    <!--&:hover{-->
      <!--box-shadow:0px 4px 12px rgba(0,0,0,0.16);-->
      <!--border-radius:5px;-->

      <!--.unfinish {-->
        <!--background: url("../../static/images/web/unfinishHover.png") no-repeat;-->
        <!--background-size: cover;-->
      <!--}-->
      <!--.finish {-->
        <!--background: url("../../static/images/web/finishHover.png") no-repeat;-->
        <!--background-size: cover;-->
      <!--}-->
      <!--.draft {-->
        <!--background: url("../../static/images/web/draftHover.png") no-repeat;-->
        <!--background-size: cover;-->
      <!--}-->
      <!--p{-->
        <!--&:first-child {-->
          <!--color:rgba(236,28,28,1);-->
        <!--}-->
        <!--&:last-child{-->
          <!--color:rgba(236,28,28,1);-->
        <!--}-->
      <!--}-->
    <!--}-->
    <!--p{-->
      <!--font-size:14px;-->
      <!--font-family:Source Han Sans SC;-->
      <!--font-weight:400;-->
      <!--&:first-child{-->
        <!--margin-top: 48px;-->
        <!--font-size:26px;-->
        <!--color:rgba(41,2,2,1);-->
      <!--}-->
      <!--&:last-child{-->
        <!--color:rgba(41,2,2,0.65);-->
        <!--/*text-decoration:underline;*/-->
      <!--}-->
    <!--}-->
  <!--}-->
  <!--.wj{-->
    <!--width: 160px;-->
    <!--height: 200px;-->
    <!--text-align: center;-->
    <!--margin-right: 80px;-->
    <!--p{-->
      <!--font-size:14px;-->
      <!--font-family:Source Han Sans SC;-->
      <!--font-weight:400;-->
      <!--color:rgba(41,2,2,0.65);-->
      <!--&:first-child{-->
        <!--margin-top: 68px;-->
      <!--}-->
      <!--&:last-child{-->
        <!--color:rgba(41,2,2,1);-->
        <!--text-decoration:underline;-->
        <!--font-size:26px;-->
      <!--}-->
    <!--}-->
    <!--p:last-child{-->
      <!--text-decoration:none;-->
    <!--}-->
  <!--}-->

  <!--.file-box{-->
    <!--/*flex: none;*/-->
    <!--width:270px;-->
    <!--height:200px;-->
    <!--background:rgba(255,255,255,1);-->
    <!--box-shadow:0px 1px 12px rgba(0,0,0,0.16);-->
    <!--opacity:1;-->
    <!--border-radius:5px;-->
    <!--text-align: center;-->
    <!--margin-right: 20px;-->
    <!--cursor: pointer;-->
    <!--&:hover{-->
      <!--box-shadow:0px 8px 28px rgba(0,0,0,0.16);-->
      <!--p{-->
        <!--color:rgba(236,28,28,1);-->
        <!--&:last-of-type{-->
          <!--color:rgba(236,28,28,0.45);-->
        <!--}-->
      <!--}-->
    <!--}-->
    <!--&:last-child{-->
      <!--margin-right: 0;-->
    <!--}-->
    <!--img{-->
      <!--display: block;-->
      <!--margin: 45px auto 5px auto;-->
      <!--width: 65px;-->
      <!--height: 65px;-->
    <!--}-->
    <!--p{-->
      <!--line-height: initial;-->
      <!--font-size:18px;-->
      <!--font-family:Source Han Sans SC;-->
      <!--font-weight:bold;-->
      <!--color:rgba(41,2,2,1);-->
      <!--opacity:1;-->
      <!--&:last-of-type{-->
        <!--font-size:12px;-->
        <!--font-family:Source Han Sans SC;-->
        <!--font-weight:400;-->
        <!--color:rgba(41,2,2,0.45);-->
      <!--}-->
    <!--}-->
  <!--}-->

  <!--.icon{-->
    <!--cursor: pointer;-->
    <!--width: 20px;-->
    <!--height: 20px;-->
    <!--margin-left: 20px;-->
  <!--}-->
  <!--.bon{-->
    <!--display: flex;-->
    <!--justify-content: space-between;-->
    <!--align-items: center;-->
    <!--padding: 33px 75px 33px 15px;-->
    <!--margin-bottom: 20px;-->
    <!--a{-->
      <!--display: flex;-->
      <!--justify-content: flex-start;-->
      <!--align-items: center;-->
      <!--cursor: pointer;-->
      <!--color: #290202;-->
      <!--&:hover{-->
        <!--color: #EC1C1C;-->
        <!--.icon-play{-->
          <!--background: url("/images/web/icon-play-on.png") no-repeat center;-->
          <!--background-size: auto 100%;-->
        <!--}-->
        <!--.icon-w1{-->
          <!--background: url("/images/web/icon-w1-on.png") no-repeat center;-->
          <!--background-size: auto 100%;-->
        <!--}-->
      <!--}-->
      <!--i{-->
        <!--width: 15px;-->
        <!--height: 15px;-->
        <!--margin-right: 10px;-->
        <!--vertical-align: middle;-->
      <!--}-->
    <!--}-->
  <!--}-->
  <!--.senior{-->
    <!--.top{-->
      <!--h1{-->
        <!--padding-left: 16px;-->
        <!--font-size:16px;-->
        <!--font-weight: normal;-->
        <!--span{-->
          <!--vertical-align: middle;-->
          <!--color: #ff8800;-->
          <!--font-size: 20px;-->
          <!--margin-right: 10px;-->
        <!--}-->
      <!--}-->
    <!--}-->
    <!--.com-w-btn{-->
      <!--line-height: initial;-->
      <!--padding: 5px 22px;-->
    <!--}-->
    <!--.bottom{-->
      <!--display: flex;-->
      <!--justify-content: flex-start;-->
      <!--align-items: center;-->
      <!--img{-->
        <!--width: 230px;-->
        <!--height: 125px;-->
        <!--margin: 21px 70px 3px 55px;-->
      <!--}-->
      <!--p{-->
        <!--font-size:14px;-->
        <!--font-family:Source Han Sans SC;-->
        <!--font-weight:400;-->
        <!--color:rgba(41,2,2,0.65);-->
        <!--line-height: 30px;-->
      <!--}-->
    <!--}-->
  <!--}-->
<!--</style>-->


<template>
  <div></div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  created () {
    this.$router.replace('/viewIndex');
  },
  beforeDestroy () {
  }
}
</script>



// WEBPACK FOOTER //
// pages/corp/viewIndex.vue